






























import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { DashboardViewModel } from '@/models/dashboard/DashboardViewModel';

export default Vue.extend({
  name: 'undervisningstimer-view',
  props: {
    viewModel: {
      type: Object as () => DashboardViewModel
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  async mounted() {
    await this.loadLessonHoursAverage(this.viewModel);
  },
  methods: {
    ...mapActions('dashboardStore', ['loadLessonHoursAverage']),

  },
  computed: {
    ...mapGetters('dashboardStore', ['groupEntries', 'groupKeyLabel', 'groupValueLabel', 'infoboxLabel', 'infoboxValue']),
    
  },
  watch: {
    'viewModel': {
      deep: true,
      async handler(newValue) {
        await this.loadLessonHoursAverage(this.viewModel);
        console.log(['loadLessonHoursAverage', newValue]);
      }
    }
  }

})
